import { DataSource, DateRangeFilter, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransferToSettlement extends Layout {
    daterangefilterFilter: DateRangeFilter;
    excludabletextboxH: ExcludableTextbox;
    excludabletextboxManifest: ExcludableTextbox;
    excludabletextboxOrderMove: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceTransferToSettlement: DataSource;
    switchExcludeVoided: Switch;
    textboxDateType: Textbox;
    textboxDrayMove: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxPayeeStatus: Textbox;
    textboxPayeeType: Textbox;
}
